import { Component, OnInit,OnDestroy, Input, EventEmitter, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { CUITurboTableColumn } from './cui-turbo-table-column';
import { Table } from 'primeng/table';
import { MenuItem } from 'primeng/primeng';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'cui-turbo-table',
  templateUrl: './cui-turbo-table.component.html',
  styleUrls: ['./cui-turbo-table.component.css'],
  encapsulation:ViewEncapsulation.None
})
export class CuiTurboTableComponent implements OnInit {

    @Input() tableColumns: CUITurboTableColumn;    
    @Input() tableData: any[] = [];
    @Input() identityColumn: string = 'id';
    @Input() contextMenu: MenuItem[] = [];

    @Input() rowsPerPage: number = 10;
    @Input() selection: any[] = [];
    @Input() selectionmode: string;


    @Input() emptyDisplayMessage : string;
    @Input() totalRecords: number = 0;
    @Input() filterDelay: number = 1500;
    @Input() enableCheckbox: boolean = false;
    @Input() enableContextMenu: boolean = true;
    @Input() sortField: string;
    @Input() sortOrder: number = 1;
    @Output() onLazyLoad: EventEmitter<any> = new EventEmitter();
    @Output() selectionChange: EventEmitter<any> = new EventEmitter();
    @Output() onClick: EventEmitter<any> = new EventEmitter();
    @Output() onContextMenuSelect: EventEmitter<any> = new EventEmitter();
    @ViewChild('Table') private turboTable: Table;

    @Output() onActionButtonClick: EventEmitter<any> = new EventEmitter();


    @Input() loading: boolean;

    filterTimeout = null;
    globalFilter: string;
    lazyloadTimer: any;
    lazyloadTimerSubscription: Subscription;
    routeSubscription: Subscription;


    constructor(private route: ActivatedRoute) {

    }

    ngOnInit() {
        this.selectionmode = this.enableCheckbox ? 'none' : this.selectionmode;
        this.subscribeToRouteParamChanges();
    }


    emitLazyLoad(event): void {
        try {

            if (this.lazyloadTimerSubscription) {
                this.lazyloadTimerSubscription.unsubscribe();
                this.lazyloadTimerSubscription = null;
            }
            this.lazyloadTimer = null;
            this.lazyloadTimer = Observable.timer(100);
            this.lazyloadTimerSubscription = this.lazyloadTimer.subscribe(t => {
                this.onLazyLoad.emit({
                    filter: this.globalFilter,
                    first: event.first,
                    rows: event.rows,
                    sortField: event.sortField,
                    sortOrder: event.sortOrder,
                });
            });


        }
        catch (e) {

            if (this.lazyloadTimer) {
                this.lazyloadTimer = null;
                if (this.lazyloadTimerSubscription) {
                    this.lazyloadTimerSubscription.unsubscribe();
                }
                this.lazyloadTimerSubscription = null;

            }
        }

    }


    emitSelection(event): void {
        this.selectionChange.emit(event);
    }

    emitContextMenu(event): void {
        this.onContextMenuSelect.emit(event);
    }

    private subscribeToRouteParamChanges() {
        //this.routeSubscription = this.route.parent.params.subscribe(params => {
        //    this.turboTable.reset();
        //});
    }

    emitButtonClick(rowData, ActionType)
    {
        this.onActionButtonClick.emit({ data: rowData, type: ActionType});
    }

}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-turbo-table/cui-turbo-table.component.ts